import React, { forwardRef } from 'react';
import classNames from 'classnames/bind';
import { CheckLinear, MinusSmallLinear } from "../../icons";
import styles from './CheckboxBase.css';
var cx = classNames.bind(styles);
export var CheckboxBase = /*#__PURE__*/forwardRef(function CheckboxBase(_ref, ref) {
  var checked = _ref.checked,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {} : _ref$classes,
      disabled = _ref.disabled,
      id = _ref.id,
      indeterminate = _ref.indeterminate,
      invalid = _ref.invalid,
      name = _ref.name,
      onChange = _ref.onChange,
      readOnly = _ref.readOnly,
      required = _ref.required,
      tabIndex = _ref.tabIndex,
      theme = _ref.theme,
      value = _ref.value;
  return /*#__PURE__*/React.createElement("span", {
    className: cx('root', "theme_".concat(theme), classes.root)
  }, /*#__PURE__*/React.createElement("input", {
    checked: checked,
    className: cx('input', {
      invalid: invalid,
      indeterminate: indeterminate
    }),
    disabled: disabled,
    id: id,
    name: name,
    onChange: onChange,
    readOnly: readOnly,
    ref: ref,
    required: required,
    tabIndex: tabIndex,
    type: "checkbox",
    value: value
  }), /*#__PURE__*/React.createElement("span", {
    className: cx('box', classes.box)
  }, indeterminate ? /*#__PURE__*/React.createElement(MinusSmallLinear, null) : /*#__PURE__*/React.createElement(CheckLinear, null)));
});